<template>
  <div :class = 'classes'>
    <div class = 'unit-content'>
      <div class = 'wrap'>
        <div :class = '{"concentration-line": unit.type === "concentration"}'></div>
        <i v-if = 'unit.type === "concentration"' class = 'concentration-icon fas fa-circle'></i>
        <div class = 'unit-name' @click = 'goToPlans' :style = 'nameStyle'>
          <div class = 'unit-name-wrap'>
            <div class = 'unit-type'>{{ type }}</div>
            {{ label }}
          </div>
        </div>
        <template v-if = 'active'>
          <div class = 'unit-level'>
            <span v-if='level'>{{ level }}</span>
          </div>
          <div class = 'unit-availability'>
            <span v-if = 'onlineAvailability'>{{ onlineAvailability }}</span>
          </div>
          <div class = 'unit-plans'>
            <span v-if = 'planPeriod'>{{ planCount }} {{ planString }}</span>
          </div>

          <div class = 'unit-credits'>
            <span v-if = 'planPeriod'>{{ planPeriod.major_credits }} Credits</span>
          </div>

          <router-link :to = '{ name: "unit-info", params: unitParams }'>
            <button  v-if = 'unit.hasInfo || unit.cip_code' class = 'hollow'>Info</button>
          </router-link>

          <router-link :to = '{ name: "unit-plans", params: unitParams }' >
            <button v-if = 'planPeriod' class = 'hollow'>{{ planString }}</button>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['unit'],

  computed: {
    level() {
      if (this.unit.sub_program_level) {
        return this.unit.sub_program_level.code
      } else if (this.unit.program_level) {
        return this.unit.program_level.code
      } else {
        return ''
      }
    },
    onlineAvailability() {
      if (this.unit.online_availability === undefined || this.unit.online_availability == 0) {
        return null
      } else {
        return this.unit.online_availability
      }
    },
    label() {
      return `${this.name}`// (${this.code})`
    },
    type() {
      const type = this.unit.type
      if (type === 'concentration') {
        return process.env.CONCENTRATION_NAME
      }
      return process.env.PROGRAM_NAMING
    },
    name() {
      return (this.unit[this.unit.type] || {}).name
    },
    code() {
      return (this.unit[this.unit.type] || {}).code
    },
    showArchived() {
      return this.$store.state.showArchived
    },
    active() {
      return !this.unit.inactive
    },
    periodId() {
      return this.$store.getters.currentPeriod.id
    },
    classes() {
      return {
        'unit-item': true,
        'major-listing': true,
        'active': this.active
      }
    },
    nameStyle() {
      if (this.active && this.planPeriod) return {cursor: 'pointer'}
    },
    planString() {
      return this.plan_count > 1 ? 'Plans' : 'Plan'
    },
    planCount() {
      return this.planPeriod.plan_count
    },
    planPeriod() {
      return this.unit.currentPlanPeriod
    },
    unitParams() {
      return {
        period_id: this.periodId,
        layout_id: this.unit.university_layout_id
      }
    }
  },
  methods: {
    goToPlans() {
      if (this.active && this.planPeriod) {
        this.$router.push({
          name: 'unit-plans',
          params: this.unitParams
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// unit_current.vue?6ea1c9b0